<template lang="">
  <div>
    <section id="subVisual" class="subVis2">
      <div>
        <h2>DiCentral Service</h2>
        <p>
          온크루소프트는 축적된 노하우와 기술력으로, 최적의 솔루션과 서비스를
          제공하겠습니다.
        </p>
      </div>
    </section>

    <main id="cont">
      <div id="overview" class="subCon"></div>
      <div class="subCon caseCon">
        <section id="ediplatform">
          <br />

          <div class="inner_box">
            <section class="subsc">
              <h3 id="scm" class="con_tit">SCM</h3>

              <h4 class="con_subtit">
                DiCentral SCM은 EDI 디지털 물류 관리 솔루션을 통해<br />
                거래 파트너와의 신속하고 효율적인 제어를 실현합니다.<br />
                DiCentral SCM은 연결성을 개선하고 데이터에 대한 빠른 액세스를
                제공하여<br />
                의사 결정을 개선 할 수 있는 클라우드 기반의 공급 솔루션을
                제공합니다.
              </h4>

              <div class="damage">
                <dl>
                  <dt>SCM 도입효과</dt>
                  <dd>
                    <ol>
                      <li>
                        <span>01</span>
                        <em
                          >자동화 주문 요청 및 재고 관리 도구로 비즈니스 성장을
                          지원합니다.</em
                        ><br /><br />
                        - 정확한 주문 관리를 위해 여러 주문 유형과 재고 상태
                        동기화를 통해 고객의 요구에 따라 재고 관리를
                        극대화합니다.<br />
                        - 재고 관리를 강화하고 주문 처리를 강화하기 위해, 주문
                        및 재고 창고 관리를 EDI 솔루션과 동기화합니다. EDI
                        데이터를 회계 시스템 또는 백 오피스 시스템에 직접
                        통합함으로써 수동으로 데이터 입력을 줄일 수 있습니다.<br />
                        - 여러 세일즈 채널에서 End-to-End 창고간의 가시성
                        보고서를 제공합니다. 주문 시 창고 내의 품목 및 수량 별
                        재고 상태 파악이 가능합니다.<br />
                        - 대량 및 단일 SKU(stock keeping unit, 재고 유지 최소
                        단위) 관리 프로그램을 지원하는 End-to-End 주문 관리의
                        유연성.
                      </li>
                      <li>
                        <span>02</span>
                        <em>클라우드 기반 주문 및 통합 창고 관리 도구 입니다</em
                        ><br /><br />
                        - DiCentral 클라우드 기반의 창고 관리를 통해 창고
                        운영자는 한 개 혹은 여러 개의 창고에서 유입되는 상품의
                        수량, 위치 및 상태를 포괄적으로 시각화 할 수
                        있습니다.<br />
                        - 신속한 구현과 사용 편의성을 위한 중앙 집중화 된 설계로
                        DiCentral 클라우드 기반의 창고 관리 시스템은 직원의
                        생산성을 향상시키고 재고 비용을 절감하며 고객 만족도를
                        향상시킵니다.<br />
                        - 사전 모니터링을 통해 재고를 추적하고 부족한 재고로
                        인한 지연에 대응할 수 있습니다.<br />
                        - 실시간 Alert을 통해 수요 변화의 가시성을 부여하여
                        잠재적인 병목 현상을 예측할 수 있습니다.<br />
                        - 바코드 또는 RFID (무선 주파수 식별) 데이터를 인식하고
                        물류 담당자가 데이터 수집 및 트랜잭션을 자동화 할 수
                        있는 다른 스케닝 장비와 호환됩니다.<br />
                      </li>
                      <li>
                        <span>03</span>
                        <em
                          >제품의 판매 및 배포를 관리하는 수동 프로세스는 이제
                          불필요 합니다. 해외 총판과 연결 및 관리하고, 판매자,
                          스토어 및 POS(Point-of-Sale)를 라우팅 합니다.</em
                        ><br /><br />
                        - 예측 모듈에서 과거 오더 패턴을 분석하여 오차가 많은
                        경우 재 주문을 제안 합니다.<br />
                        - 신속한 재고의 최적화를 사용하여 재고 부족을 막아 매출
                        증가로 이어집니다.<br />
                        - B2B, B2C 및 제품 프로모션 관리<br />
                        - WMS 및 ERP 시스템과의 통합을 지원하여 주문 상태,
                        history, 재고 수준을 확인 할 수 있습니다.<br />
                        - 과거 데이터에 액세스하여 보다 빠르고 효율적인
                        의사결정을 할 수 있습니다.
                      </li>
                      <li>
                        <span>04</span>
                        <em
                          >클라우드 기반 POS(Point-of-Sale) 솔루션 으로,
                          구매자와 공급자가 판매 데이터를 수집, 분석 및 공유할
                          수 있습니다.</em
                        ><br /><br />
                        - 품목, 위치 및 인구 통계에 의한 현저한 변화와 추세를
                        발견<br />
                        - 매일, 매주, 매월, 매년 제품 활동의 완벽한 가시성을
                        획득<br />
                        - 과잉 재고의 가능성을 특정하여 불필요한 오더 최소화<br />
                        - 수요를 충족하기 위해 구매자와 효과적으로 협력<br />
                        - 유통 계획을 위해 제품의 판매처를 결정<br />
                        - 제품 활동과 단위 비용의 비교<br />
                        - 제품의 경향을 측정하여 제품의 가용성을 판단합니다.<br />
                        - 아이템, 시즌, 스타일 및 고객별로 수익성 측정<br />
                        - 판매 및 재고를 위탁 프로그램과 비교<br />
                        - 생산 계획을 위한 판매 보고서 예측 전략 분석합니다.<br />
                      </li>
                    </ol>
                  </dd>
                </dl>
              </div>
              <br /><br /><br /><br /><br /><br /><br /><br /><br />
              <h3 id="web" class="con_tit">Web EDI</h3>

              <h4 class="con_subtit">
                DiCentral의 광범위한 파트너십 네트워크를 활용하여 고객 EDI
                요구사항을 신속하게 수행합니다.<br />
                DiCentral의 클라우드 기반 EDI 솔루션을 사용하면 EDI 소프트웨어
                또는 하드웨어에 투자할 필요가<br />
                없이 비즈니스를 확장하여 문서의 흐름을 신속하게 자동화하고<br />
                order를 수행 하며, 백 오피스 (back-office) 시스템과 통합할 수
                있습니다.
              </h4>

              <div class="damage">
                <dl>
                  <dt>Web EDI 도입효과</dt>
                  <dd>
                    <ol>
                      <li>
                        <span>01</span>
                        <em>EASY TO USE & ACCESS</em><br /><br />
                        직관적이고 현대적인 사용자 환경이 단계별 트랜잭션 처리를
                        제공합니다. 웹 브라우저만 있으면 됩니다.
                      </li>
                      <li>
                        <span>02</span>
                        <em>DEDICATED SUPPORT</em><br /><br />
                        DiCentral의 24x7(365일) 글로벌 지원팀에 전화를 걸거나
                        이메일을 보내시면 모든 EDI질문에 대해 신속한 해결을
                        얻습니다.
                      </li>
                      <li>
                        <span>03</span>
                        <em
                          >COMPLY WITH CUSTOMERS’EDI & FULFILLMENT
                          REQUIREMENTS</em
                        ><br /><br />
                        기능이 풍부한 클라우드 기반 툴은 고객의 진화하는 EDI
                        프로그램 및 각각의 요구사항을 충족할 수 있습니다.
                        DiCentral의 웹 EDI 솔루션은 구현이 간단하며 조직의
                        성장에 따라 확장성도 우수합니다.
                      </li>
                      <!--		<li>
								<span>04</span>
								<em>COST EFFECTIVE</em><br><br>
								DiCentral의 웹 EDI 플랫폼을 사용하여 거래처와 즉시 연결하는 비용은 $30/월 입니다.							
							</li>  -->
                      <li>
                        <span>04</span>
                        <em>ERP INTEGRATION</em><br /><br />
                        웹 브라우저 상에서 회계/ERP 시스템과 완벽한 통합과
                        전환(EDI integration)을 경험할 수 있습니다.
                      </li>
                      <li>
                        <span>05</span>
                        <em>REAL-TIME VISIBILITY ACROSS YOUR SUPPLY CHAIN</em
                        ><br /><br />
                        특정 역할 및 기본 설정에 따른 실시간 정보를 필터링
                        합니다.
                      </li>
                      <li>
                        <span>06</span>
                        <em>MOBILE ALERTS</em><br /><br />
                        태블릿 pc 또는 스마트폰으로 실시간 알림 경고를 적용하여
                        유통 및 물류의 지연 요소를 제거하고 중요 트랜잭션에 신속
                        대응 할 수 있습니다.
                      </li>
                    </ol>
                  </dd>
                </dl>
              </div>
              <br /><br /><br /><br /><br /><br /><br /><br /><br />
              <h3 id="3pl" class="con_tit">3PL</h3>
              <h4 class="con_subtit">
                귀사가 3PL 협력 업체이든, 제조업체이든 상관없이<br />
                DiCentral의 on-demand EDI 기능을 사용하면<br />
                최소한의 비용과 위험부담을 줄여 자유롭게 스케일을 늘이고 줄일 수
                있습니다.<br />
                (소프트웨어, 하드웨어의 구매 및 설치가 필요 없어 고객이 원하는
                시점에 요구사항을 수행할 수 있습니다.)
              </h4>
            </section>
          </div>
        </section>
        <br /><br />

        <section class="platform1">
          <h3 id="integrate" class="con_tit">Integrate</h3>

          <div class="img" style="background-color: #fbfbfb">
            <v-img
              src="@/assets/img/dicentral/ediservice/dna.png"
              alt=""
              style="
                width: 55%;
                margin: 0 auto;
                max-width: 55%;
                align-items: center;
              "
            />
            <br /><br />
          </div>

          <br />
          <h4 class="con_subtit">
            DiCentral Integrate는 거래 파트너 커뮤니티에서 EDI 데이터를
            통합함으로써<br />
            ERP 투자 수익을 높이고 협업을 자동화하여 오류가 발생하기 쉬운 중복
            데이터 입력을 줄일 수 있습니다.<br />
            기존의 EDI 공급자는 ERP 통합 기술을 타사 공급 업체에 아웃소싱
            합니다.<br />
            DiCentral 사전에 구축 된 자체 ERP 어댑터는 DiCentral의 EDI 클라우드
            플랫폼과 연계하여<br />
            100 개 이상의 ERP, WMS 및 회계 시스템과 통합 할 수 있도록 설계되어
            있습니다.
          </h4>
          <div class="img" style="display: flex">
            <v-img
              src="@/assets/img/dicentral/ediservice/superp2.png"
              alt=""
              style="margin: 0 auto; max-width: 55%; align-items: center"
            />
            <br /><br />
          </div>
        </section>

        <div class="con" style="height: 140px">
          <br />
        </div>

        <h3 id="auto" class="con_tit">Automotive</h3>
        <h4 class="con_subtit">
          DiCentral 강력한 클라우드 기반의 자동차 EDI 및 릴리스 관리 솔루션은
          수백 거래 파트너가<br />
          OEM, Tier 1, Tier 2 자동차 제조 릴리스 관리와 출하 요건을 충족 할 수
          있습니다.<br />
          클라우드 기반의 자동차 EDI 솔루션은 각 자동차 거래 파트너의 특정 요구
          사항을 충족하기 위해<br />
          EDI 통신, 번역, 예약 / 예측, 바코드 라벨 인쇄, 스캔이 포함됩니다.<br />
          DiCentral의 EDI 자동차 솔루션 공급 업체 및 공급 업체와 원활하게
          거래하고 MMOG 지침을 준수 할 수 있습니다.<br />
          DiCentral의 EDI 솔루션은 자동차 공급망의 요구에<br />
          자신을 적응 할 수 있기 때문에 조립의 각 단계에서 실시간 통신 및 추적이
          가능합니다.
        </h4>

        <div class="inner_box">
          <section class="subsc">
            <div class="damage">
              <dl>
                <dt>
                  Automotive<br />
                  도입효과
                </dt>
                <dd>
                  <ol>
                    <li>
                      <span>01</span>
                      <em>AUTOMOTIVE CERTIFICATIONS</em><br /><br />
                      - 혼다와 GM이 인증<br />
                      - 포드, 스바루, 크라이슬러, 닛산, 도요타, 마쓰다,
                      미쓰비시, 볼보, Caterpillar의 EDI 요구 사항을 준수
                    </li>
                    <li>
                      <span>02</span>
                      <em>AUTOMOTIVE EDI COMPLIANCE</em><br /><br />
                      - X12 EDI 및 EDIFACT를 포함한 모든 자동차 EDI 트랜잭션
                      세트를 지원<br />
                      - AS2, AS3, ebXML, FTP / FTP, SSH FTP, HTTP / HTTP 및
                      MLLP, OFTP / OFTP2, RNIF, SMTP / SMTP 및 Web 서비스를
                      포함한 모든 자동차 산업용 통신 프로토콜을 지원<br />
                      - 라인 사이드 바코드 라벨
                    </li>
                    <li>
                      <span>03</span>
                      <em>LABELING OPTIONS</em><br /><br />
                      - 생산 라인에 직접 라벨 부품<br />
                      - 개별 거래 파트너의 요구 사항에 따라 라벨<br />
                      - 트랙이로드되면 준비된 ASN에 시리얼을로드합니다<br />
                      - 정확한 ASN을위한 바코드 라벨 배치 스캔
                    </li>
                    <li>
                      <span>04</span>
                      <em>FORECAST & PLANNING</em><br /><br />
                      클라우드 기반 POS(Point-of-Sale) 솔루션 으로, 구매자와
                      공급자가 판매 데이터를 수집, 분석 및 공유할 수 있습니다.
                    </li>
                    <li>
                      <span>05</span>
                      <em>SHIPPING MODULE</em><br /><br />
                      - 수신 문서에서 주문을 자동으로 추출하고 데이터 파일에
                      추가합니다.<br />
                      - 확정 주문의 표시 변경, 추가가 가능<br />
                      - 기본 출하 정보 (Advance Ship Notice / ASN 또는 Despatch
                      Advice / DESADV) 정보를 자동으로 작성<br />
                      - 출하 할 위치 선적 시간을 기준으로 출하 확정 주문을
                      자동으로 할당합니다.<br />
                      - 배송에서 주문을 수동으로 할당하거나 제거 할 수
                      있습니다.<br />
                      - 배송 상황을 추적 및 표시 지연 출하를 강조 표시합니다
                    </li>
                    <li>
                      <span>06</span>
                      <em>ERP/MRP INTEGRATION</em><br /><br />
                      - ERP / MRP 투자의 더 큰 수익을 달성하기<br />
                      - 마진을 줄이고, 고객과의 관계를 위태롭게 할 수있는 오류가
                      발생하기 쉬운 데이터 입력을 줄일 수 있습니다
                    </li>
                  </ol>
                </dd>
              </dl>
            </div>
          </section>
        </div>
      </div>
    </main>
  </div>
</template>
<script>
export default {};
</script>
<style lang=""></style>
